import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useModal } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal';
import { useTour } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Tour';
import { formatTourDataWithStepsViewed } from '@monorepo/shared/src/util/tour-data-utils';
import { isActiveLicense } from '@monorepo/shared/src/graph/selectors/license-selector';
import useTourStore from '@monorepo/shared/src/graph/state/query-hooks/use-tour';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
import OnboardingModal from './modals/OnboardingModal';
import Home from '../../Home';
import { TourName } from 'types';

const { REACT_APP_APP_NAME: appName } = process.env;

const Onboarding: React.FC = () => {
  const [{ isOpen: isModalOpen }, { openModal, closeModal }] = useModal();
  const [state, { setActiveTour, setNextStep, handleExitTour, refresh }] = useTour();

  const [user] = useUserStore();
  const [{ tourData, tourSteps, loading }, { handleSaveTourSetting }] = useTourStore(
    TourName.WELCOME,
    appName
  );

  const activeStep = tourSteps?.[state?.activeStepIndex];
  const activeStepText = activeStep?.text;
  const navigate = useNavigate();
  const saveStrategy = 'SAVE_ALL_STEPS_ON_COMPLETE';

  const saveTourSetting = async (isSingleStep: boolean) => {
    if (tourData?.id && user.me?.id && tourSteps) {
      const data = formatTourDataWithStepsViewed({
        isEducator: true,
        tourId: tourData?.id,
        userOrStudentId: user.me?.id,
        tourSteps,
        isSingleStep,
        activeStepIndex: state?.activeStepIndex,
      });
      data && (await handleSaveTourSetting(data));
    }
  };

  const handleClose = async () => {
    handleExitTour();
    const isSingleStep = false;
    await saveTourSetting(isSingleStep);
    closeModal();
    handleRedirect();
  };

  const handleNextClick = async (isPrevious) => {
    const isSingleStep = true;
    await saveTourSetting(isSingleStep);

    setNextStep(isPrevious);

    if (state.isLastStep && !isPrevious) {
      handleClose();
    }
  };

  const handleRedirect = () => {
    navigate('/home');
  };

  // run on-load
  useEffect(() => {
    if (tourSteps) {
      refresh();
      setActiveTour('onboarding', tourSteps, saveStrategy);
    }
  }, [tourSteps]);

  // Open onboarding modal
  useEffect(() => {
    const license = user?.me?.licenses?.[0];
    if (state.isTourInProgress && !loading && isActiveLicense(license)) {
      openModal({
        body: (
          <OnboardingModal
            activeStepIndex={state?.activeStepIndex}
            activeStep={activeStep}
            onNextClick={handleNextClick}
            onExit={handleClose}
            isLastStep={state.isLastStep}
          />
        ),
      });
    }
  }, [
    openModal,
    activeStepText,
    isModalOpen,
    tourSteps,
    state.activeStepIndex,
    state.isTourInProgress,
    user?.me?.toursSettings,
  ]);
  return <Home />;
};

export default Onboarding;
